import React from 'react';
import { Link, graphql } from 'gatsby';

import Layout from '../components/layout';
import SEO from '../components/seo';
import { SliceZone } from '../components/SliceZone';



function IndexPage({ data: { prismicHomepage }, ...restProps }) {
  const { data } = prismicHomepage;

  return (
    <Layout {...restProps}>
      <SEO title="Home" />
      <SliceZone allSlices={data.body} />
    </Layout>
  );
}

export default IndexPage;

export const pageQuery = graphql`
  {
    prismicHomepage {
      id
      data {
        body {
          ... on PrismicHomepageBodySectionHeader {
            id
            slice_type
            primary {
              description {
                text
              }
            }
          }
          ... on PrismicHomepageBodyHomepageHero {
            id
            slice_type
            primary {
              image {
                url
              }
              headline {
                text
              }
              subheadline {
                text
              }
              cta_button_label {
                text
              }
              cta_button_link {
                url
              }
            }
          }
          ... on PrismicHomepageBodyCurrencyImageGrid {
            id
            slice_type
            items {
              image {
                url
              }
              link {
                url
              }
            }
          }
          ... on PrismicHomepageBodyCurrencyFamilyInfo {
            id
            slice_type
            primary {
              headline {
                text
              }
              subheadline {
                text
              }
              cta_label {
                text
              }
              cta_link {
                url
              }
            }
          }
          ... on PrismicHomepageBodyFeatureBoxSection {
            id
            slice_type
            items {
              icon {
                url
              }
              name {
                text
              }
              description {
                text
              }
            }
          }
          ... on PrismicHomepageBodyHomepageBanner {
            id
            slice_type
            primary {
              banner {
                url
              }
            }
          }
          ... on PrismicHomepageBodyHomepageTnf {
            id
            slice_type
            primary {
              title {
                text
              }
            }
          }
          ... on PrismicHomepageBodyHomepageAds {
            id
            slice_type
            primary {
              ad {
                url
              }
              link {
                url
              }
            }
          }
          ... on PrismicHomepageBodyHomepageDoc {
            id
            slice_type
            primary {
              tokenname {
                text
              }
              tokencontent {
                text
              }
              desc {
                text
              }
            }
            items {
              backgroundimg {
                url
              }
              docname {
                text
              }
              docurl {
                url
              }
            }
          }
          ... on PrismicHomepageBodyContactBox {
            id
            slice_type
            primary {
              headline {
                text
              }
              description {
                text
              }
              input_placeholder {
                text
              }
            }
          }
        }
      }
    }
  }
`;
